<div flexLayout="row">
    <div fxFlex="80" fxLayoutAlign="center center">
        <span class="example-pizza-party">
            {{data.conflict}}
        </span>        
    </div>
    <div fxFlex="20" fxLayoutAlign="end center">
        <button mat-raised-button style="background-color: transparent;" (click)="view()">View</button>
    </div>
</div>